(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/utils/tracking.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/utils/tracking.js');
"use strict";


const {
  mapProductType
} = svs.ticketgames.ticketMappings.productMappings;
const logger = new svs.core.log.Logger('component:ticket-scratch-tracking');
setGlobal('svs.ticketgames.ticketScratch.utils.tracking', {
  trackChooseNewTicket: gameCode => {
    const ticketType = mapProductType(gameCode);
    const ev = {
      category: 'Wager',
      action: 'ticket_choose_new',
      opt_label: ticketType
    };
    logger.debug(ev);
    svs.components.analytics.trackEvent(ev);
  },
  trackScratchAllTickets: gameCode => {
    const ticketType = mapProductType(gameCode);
    const ev = {
      category: 'VOUCHER',
      action: 'redeem_ticket',
      opt_label: ticketType
    };
    logger.debug(ev);
    svs.components.analytics.trackEvent(ev);
  },
  trackPlayAgain: (winAmount, type) => {
    const ev = {
      category: 'Wager',
      action: 'Spela igen',
      opt_value: winAmount,
      opt_label: type
    };
    logger.debug(ev);
    svs.components.analytics.trackEvent(ev);
  },
  trackQuitGame: (winAmount, type) => {
    const ev = {
      category: 'Wager',
      action: 'Avsluta',
      opt_value: winAmount,
      opt_label: type
    };
    logger.debug(ev);
    svs.components.analytics.trackEvent(ev);
  },
  gameSpecificTracking: {
    svstrissadventskalender150y22: {
      bet: () => {
        const ev = {
          category: 'TrissAdventskalender',
          action: 'bet'
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      },
      openDoor: data => {
        const {
          doorsOpened
        } = data.ticket.revelationData;
        const ev = {
          category: 'TrissAdventskalender',
          action: 'open_door',
          opt_label: doorsOpened
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      },
      corrected: () => {
        const ev = {
          category: 'TrissAdventskalender',
          action: 'corrected'
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      }
    }
  }
});

 })(window);